import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=5565f86c&"
import script from "./Legals.vue?vue&type=script&lang=js&"
export * from "./Legals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports